import React from 'react'
import { PageContent, PageLayout } from '@reapitform/dashboard-ui'
import { DashboardIcon } from '@reapit/elements/icons/dashboard'
import {
  ComingSoonCard,
  ComingSoonIconWrap,
  ComingSoonTitle,
  ComingSoonSubtitle,
  ComingSoonMetricsRow,
  ComingSoonMetricGhost,
  ComingSoonMetricGhostBar,
} from './style'

/**
 * Dashboard landing page — metrics and reporting coming soon.
 */
export const DashboardPage: React.FC = () => {
  return (
    <PageLayout pageTitle="Dashboard">
      <PageContent>
        <ComingSoonCard>
          <ComingSoonIconWrap>
            <DashboardIcon size="lg" color="action" />
          </ComingSoonIconWrap>
          <ComingSoonTitle>Metrics & Reporting — Coming Soon</ComingSoonTitle>
          <ComingSoonSubtitle>
            We&apos;re building out dashboard insights for forms, versions, and activity. Check back soon.
          </ComingSoonSubtitle>
          <ComingSoonMetricsRow>
            {[0, 1, 2].map((index) => (
              <ComingSoonMetricGhost key={index}>
                <ComingSoonMetricGhostBar />
                <ComingSoonMetricGhostBar />
              </ComingSoonMetricGhost>
            ))}
          </ComingSoonMetricsRow>
        </ComingSoonCard>
      </PageContent>
    </PageLayout>
  )
}

export default DashboardPage
